<template>
  <Navbar
    @autorotate="setAutoRotate"
    @zoomin="zoomIn"
    @zoomout="zoomOut"
    @reset="reset"
  />
  <div id="viewer" style="width: 100vw; height: 100vh"></div>
  <!-- 弹窗 -->
  <ProductInfo
    :ids="currentProductId"
    :morelink="currentMoreLink"
    v-show="isShowModal"
    @close="closeModal"
    ref="productInfoRef"
  />
  <TopologyDiagram @close="closeModal" :title="topologyDiagramTitle" :title2="introduceTitle" :imglink="topologyDiagramImg" v-show="isTopologyDiagram" />
  <!-- 导航栏 -->
  <NavBarBottom
    :activePictureId="activePictureId"
    v-model:showNavBar="showNavBar"
    @changeNavTab="changeActiveTab"
    @showMap="showTopologyDiagram"
    ref="navBarBottomRef"
  >
  </NavBarBottom>
  <video-preview
    @close="closePreview"
    @resetPageType="resetPageType"
    v-show="isShowPreview"
    :isShowPreview="isShowPreview"
    :currentPageType="previewType"
    :previewInfo="previewInfo"
    :previewZoomType="previewZoomType"
    :previewProductName="previewProductName"
    :productId="currentProductId"
  ></video-preview>
  <div class="home" v-show="activePictureId == ''">
    <div class="home-start">
      <img src="https://media.tp-link.com.cn/webresource/act/vr/images/icon/tp_logo_blue.png"/>
    </div>
    <div class="home-main">
      <img src="https://media.tp-link.com.cn/webresource/act/vr/images/icon/home_page2.png" />
      <div class="home-main-btns">
        <div class="home-main-btn" @click="initViewer('1-1-1')">教育</div>
        <div class="home-main-btn" @click="initViewer('2-1-1')">社区</div>
        <div class="home-main-btn" @click="initViewer('10-2-1')">制造</div>
      </div>
    </div>
  </div>
</template>

<script>
import pictureInfo from "@/assets/data/pictureInfo.json";
import ProductInfo from "./components/ProductInfo.vue";
import TopologyDiagram from "./components/TopologyDiagram.vue";
import Navbar from "./components/NavBar.vue";
import NavBarBottom from "./components/NavBarBottom.vue";
import VideoPreview from "./components/VideoPreview.vue";
import { Viewer, utils } from "@photo-sphere-viewer/core";
import { AutorotatePlugin } from "@photo-sphere-viewer/autorotate-plugin";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { EquirectangularTilesAdapter } from "@photo-sphere-viewer/equirectangular-tiles-adapter";
import "@photo-sphere-viewer/core/index.css";
import "@photo-sphere-viewer/markers-plugin/index.css";

import { pageType } from "@/utils/PreviewConsts";

import commom from "@/mixin/common"; // 引入 mixin
const animatedValues = {
  pitch: { start: -Math.PI / 2, end: 0 },
  yaw: { start: Math.PI / 2, end: 0 },
  zoom: { start: 0, end: 50 },
  maxFov: { start: 130, end: 90 },
  fisheye: { start: 2, end: 0 },
};

export default {
  name: "App",
  mixins: [commom],
  data() {
    return {
      prefixPath: "https://media.tp-link.com.cn/tmp/3d/images",
      allPictureInfo: [],
      //初始图片1-1-2
      // activePictureId: "1-1-12",
      activePictureId: "",
      scriptStr: `111`,
      isShowModal: false,
      isShowPreview: false,
      currentProductId: '3305',
      currentMoreLink: "https://www.tp-link.com.cn/list_2549.html",
      showNavBar: true,
      //当前容器
      viewer: null,
      //标记
      markersPlugin: null,
      autorotate: null,
      animatedValues: null,
      allPageType: pageType,
      previewType: "",
      previewType2: "",
      previewInfo: {},
      previewProductName: "",
      previewZoomType: "",
      topologyDiagramImg:"",
      topologyDiagramTitle: "教育/职业教育",
      introduceTitle: "车辆预约出入全流程介绍",
      isTopologyDiagram: false
    };
  },
  computed: {
    activePictureInfo() {
      return (
        this.allPictureInfo.find((info) => {
          return info.id == this.activePictureId;
        }) || {}
      );
    },
  },
  components: {
    ProductInfo,
    Navbar,
    NavBarBottom,
    VideoPreview,
    TopologyDiagram
  },
  methods: {
    showTopologyDiagram(title,img){
      this.isTopologyDiagram = true;
      this.topologyDiagramTitle = title;
      this.topologyDiagramImg = img;
      this.introduceTitle = ""
    },
    showIntroduceDiagram(title){
      this.isTopologyDiagram = true;
      this.topologyDiagramTitle = "";
      this.introduceTitle = title;
    },
    closeModal() {
      this.isShowModal = false;
      this.isTopologyDiagram = false;
    },
    closePreview() {
      this.isShowPreview = false;
    },
    resetPageType() {
      this.previewType = "";
      this.previewInfo = new Object();
      this.previewProductName = "";
      this.previewZoomType = "";
    },
    changeActiveTab({ tabItem, mark }) {
      let targetId = "";
      switch (mark) {
        case "LV1": {
          //找到一级分类下的第一个二级分类下的第一个三级分类
          const lv2 = tabItem.children[0];
          if (Object.keys(lv2).length > 0 && lv2.children != undefined) {
            const lv3 = lv2.children[0];
            targetId = lv3.id;
          } else {
            alert("当前顶级分类下没有图片");
          }
          break;
        }
        case "LV2": {
          if (tabItem.children != undefined) {
            const lv3 = tabItem.children[0];
            targetId = lv3.id;
          } else {
            // alert("当前二级分类下没有图片");
          }
          break;
        }
        case "LV3": {
          targetId = tabItem.id;
          break;
        }
      }
      // this.activePictureId = targetId;
      if (targetId == "") {
        console.log("未找到图片targetId:null");
        return;
      }

      let targetPictureInfo =
        this.allPictureInfo.find((info) => {
          return info.id == targetId;
        }) || {};
      if (Object.keys(targetPictureInfo).length == 0) {
        alert("当前分类下没有场景图");
      }
      if (
        Object.keys(targetPictureInfo).length > 0 &&
        this.activePictureId != targetId
      ) {
        this.activePictureId = targetId;
        //重新设置图片
        this.switchScene();
        console.log("重新设置图片");
      }
    },
    setAutoRotate() {
      this.autorotate.start();
    },
    zoomIn() {
      this.viewer.animate({
        zoom: this.viewer.getZoomLevel() + 50,
        speed: 1000,
      });
    },
    zoomOut() {
      this.viewer.animate({
        zoom: this.viewer.getZoomLevel() - 50,
        speed: 1000,
      });
    },
    reset() {
      this.viewer.animate({
        yaw: animatedValues.yaw.end,
        pitch: animatedValues.pitch.end,
        zoom: 50,
        speed: 1000,
      });
    },
    //  场景切换
    switchScene() {
      if (
        this.activePictureInfo == undefined ||
        Object.keys(this.activePictureInfo).length == 0
      ) {
        alert("当前没有场景图");
        console.log("当前没有场景图");
        return;
      }
      let panorama = {
        width: 12000,
        cols: this.activePictureInfo.cols,
        rows: this.activePictureInfo.rows,
        baseUrl:
          `/webresource/act/vr/images/${this.activePictureInfo.id}/img_low.jpg` +
          (this.activePictureInfo.version
            ? `?${this.activePictureInfo.version}`
            : ""),
        tileUrl: (col, row) => {
          return (
            `/webresource/act/vr/images/${this.activePictureInfo.id}/img_${col}_${row}.jpg` +
            (this.activePictureInfo.version
              ? `?${this.activePictureInfo.version}`
              : "")
          );
        },
      };
      if(process.env.NODE_ENV === "development"){
        console.log(this.activePictureInfo);
      }
      
      let currentYaw = this.activePictureInfo.yaw ? this.activePictureInfo.yaw * Math.PI / 180 : 0;
      let currentPitch = this.activePictureInfo.pitch ? this.activePictureInfo.pitch * Math.PI / 180 : 0;

      // 切换全景图并应用过渡效果;
      this.viewer
        .setPanorama(panorama, {
          transition: true,
          transitionDuration: 1500,
          cache: true,
          position: { yaw: currentYaw, pitch: currentPitch },
          zoom: 50,
        })
        .then(() => {
          // 重新配置标记
          this.markersPlugin.clearMarkers();
          this.markersPlugin.setMarkers(this.activePictureInfo.markers);
          // 重新初始化工具提示
          this.activePictureInfo.markers.forEach((marker) => {
            this.markersPlugin.showMarkerTooltip(marker.id);
          });
          document
            .querySelectorAll(".psv-marker--has-tooltip")
            .forEach((item) => {
              item.style.visibility = "visible";
            });
        })
        .catch(console.error);
    },
    loadExternalScript() {
      let uniqueProductIds = new Set();

      this.allPictureInfo.forEach((item) => {
        if (item.markers && Array.isArray(item.markers)) {
          item.markers.forEach((marker) => {
            if (marker.productId !== undefined && marker.productId != 0) {
              uniqueProductIds.add(marker.productId);
            }
          });
        }
      });

      let productIdArray = Array.from(uniqueProductIds);

      //console.log('productIdArray', productIdArray);
      const script = document.createElement("script");
      script.src = `https://www.tp-link.com.cn/publicservice/vrproductsinfo?productIds=${productIdArray.join(
        ","
      )}`;
      script.type = "text/javascript";
      script.async = true; // 异步加载，防止阻塞页面

      script.onload = () => {
        //console.log("脚本加载完成");
      };

      script.onerror = () => {
        console.error("无法加载脚本: " + script.src);
      };

      document.head.appendChild(script);
    },
    createActiveAreaStyle() {
      const script = document.createElement("script");
      script.src =
        `https://media.tp-link.com.cn/webresource/act/vr/config.js?` +
        new Date().getTime();
      script.type = "text/javascript";
      script.async = true; // 异步加载，防止阻塞页面

      script.onload = () => {
        if (window.AppConfig?.isShowActiveArea) {
          const style = document.createElement("style");
          style.innerHTML = `
        .custom-maker-container {
          background: red ;
          opacity: 0.5 ;
        }
        .product-hover{
          background: red ;
          opacity: 0.5 ;
        }
      `;
          document.head.appendChild(style);
        }
        console.log("window.AppConfig");
        console.log(window.AppConfig);
      };

      script.onerror = () => {
        console.error("无法加载脚本: " + script.src);
      };

      document.head.appendChild(script);
    },
    initViewer(id) {
      this.activePictureId = id;
      if(id == '2-1-1'){
        document.querySelectorAll('.nav-label-def')[1].click()
      }
      if(id == '10-2-1'){
        document.querySelectorAll('.nav-label-def')[2].click()
      }
      const viewer = new Viewer({
        container: "viewer",
        cache: true,
        adapter: EquirectangularTilesAdapter,
        panorama: {
          width: 12000,
          cols: this.activePictureInfo.cols,
          rows: this.activePictureInfo.rows,
          baseUrl:
            `/webresource/act/vr/images/${this.activePictureInfo.id}/img_low.jpg` +
            (this.activePictureInfo.version
              ? `?${this.activePictureInfo.version}`
              : ""),
          tileUrl: (col, row) => {
            return (
              `/webresource/act/vr/images/${this.activePictureInfo.id}/img_${col}_${row}.jpg` +
              (this.activePictureInfo.version
                ? `?${this.activePictureInfo.version}`
                : "")
            );
          },
        },
        navbar: false,
        defaultPitch: animatedValues.pitch.start,
        defaultYaw: animatedValues.yaw.start,
        defaultZoomLvl: animatedValues.zoom.start,
        maxFov: animatedValues.maxFov.start,
        fisheye: animatedValues.fisheye.start,
        //loadingImg: 'https://photo-sphere-viewer-data.netlify.app/assets/loader.gif',
        mousemove: false,
        mousewheel: false,
        plugins: [
          [
            AutorotatePlugin,
            {
              autostartDelay: null,
              autostartOnIdle: false,
              autorotatePitch: 0,
              autorotateSpeed: "0.2rpm",
            },
          ],
          [
            MarkersPlugin,
            {
              markers: this.activePictureInfo.markers,
            },
          ],
        ],
      });

      this.viewer = viewer;

      const autorotate = viewer.getPlugin(AutorotatePlugin);
      const markersPlugin = viewer.getPlugin(MarkersPlugin);
      this.markersPlugin = markersPlugin;
      let isInit = true;
      this.autorotate = autorotate;

      // 监听工具提示显示事件
      markersPlugin.addEventListener("show-tooltip", () => {
        console.log("show-tooltip");
      });

      // setup timer for automatic animation on startup
      viewer.addEventListener(
        "ready",
        () => {
          setTimeout(() => {
            if (isInit) {
              intro(animatedValues.pitch.end, animatedValues.pitch.end);
            }
          }, 3000);
        },
        { once: true }
      );

      // launch animation to clicked point
      viewer.addEventListener("click", ({ data }) => {
        if (isInit) {
          intro(data.pitch, data.yaw);
        }
        if (process.env.NODE_ENV === "development") {
          console.log('pitch',data.pitch,'yaw', data.yaw);
        }
      });

      let that = this;

      // perform the intro animation
      function intro(pitch, yaw) {
        isInit = false;
        autorotate.stop();

        new utils.Animation({
          properties: {
            ...animatedValues,
            pitch: { start: animatedValues.pitch.start, end: pitch },
            yaw: { start: animatedValues.yaw.start, end: yaw },
          },
          duration: 2500,
          easing: "inOutQuad",
          onTick: (properties) => {
            viewer.setOptions({
              fisheye: properties.fisheye,
              maxFov: properties.maxFov,
            });
            viewer.rotate({ yaw: properties.yaw, pitch: properties.pitch });
            viewer.zoom(properties.zoom);
          },
        }).then(() => {
          //展示标记的文本，产品名称
          // 展示所有标记的tooltip
          that.activePictureInfo.markers.forEach((marker) => {
            markersPlugin.showMarkerTooltip(marker.id);
          });
          document
            .querySelectorAll(".psv-marker--has-tooltip")
            .forEach((item) => {
              item.style.visibility = "visible";
            });
          setTimeout(() => {
            autorotate.start();
          }, 1000);
          viewer.setOptions({
            mousemove: true,
            mousewheel: true,
          });
        });
      }
      //预览画面类型由previewType决定，是否展示预览弹窗由isShowPreview决定
      //在这两个click事件中分别赋值

      // 监听标记点击事件
      markersPlugin.addEventListener("select-marker", ({ marker }) => {
        console.log(marker.config);

        //场景跳转
        if(marker.config.scenceId && marker.config.scenceId != ''){
          this.changeActiveTab({
              tabItem:{
                id: marker.config.scenceId,
                level:3,
                title:marker.config.productName,
                visible: true
            },mark:'LV3'
          });
          if(marker.config.parentScenceId){
            this.$refs.navBarBottomRef.activeIdLv2 = marker.config.parentScenceId;
            this.$refs.navBarBottomRef.tempPictureId = marker.config.scenceId;
          }
          return;
        }

        //设置预览页面类型
        this.previewType2 = marker.config.previewType2;
        this.previewType = marker.config.previewType;
        this.previewInfo = marker.config.previewInfo;
        this.previewProductName = marker.config.productName;
        this.previewZoomType = marker.config.previewZoomType;
        this.topologyDiagramImg = marker.config.introductionImgUrl;

        if (marker.config.productId == 0) {
          return;
        }
        this.currentProductId = marker.config.productId.toString();
        if (marker.config.moreLink) {
          this.currentMoreLink = marker.config.moreLink;
        } else {
          this.currentMoreLink = "";
        }
        
        this.isShowModal = true;
        if (
          this.$refs.productInfoRef &&
          this.$refs.productInfoRef.reset
        ) {
          this.$refs.productInfoRef.reset(); // 调用子组件方法
        }
        
      });

      document.querySelector(".psv-markers").addEventListener("click", (e) => {
        console.log("psv-markers", e.target.classList);
        if (e.target.classList.contains("tip-preview")) {
          if(e.target.classList.contains("tip-preview3")){
            //显示介绍图
            this.showIntroduceDiagram(this.previewProductName);
            return;
          }
          this.isShowModal = false;
          if (e.target.classList.contains("tip-preview2")) {
            this.previewType = this.previewType2;
          }
          //展示预览弹窗
          if (!this.isEmptyString(this.previewType)) {
            // console.log("设置是否预览");
            //此处真正设置了预览画中画是否显示
            this.isShowPreview = true;
          } else {
            alert("缺少预览类型");
          }
        }
      });

      // 监听tooltip点击事件
      document
        .querySelector(".psv-container")
        .addEventListener("click", (e) => {
          let dataId = 0;
          // 通过class名匹配tooltip元素
          if (
            e.target.classList.contains("custom-tooltip") ||
            e.target.classList.contains("psv-tooltip-content")
          ) {
            let tooltipItem = event.target.querySelector(".tooltipitem");
            if (tooltipItem) {
              dataId = tooltipItem.getAttribute("data-id");
            }
          }
          if (e.target.classList.contains("tooltipitem")) {
            dataId = e.target.getAttribute("data-id");
          }
          if (dataId && dataId != '' && dataId != "0") {
            this.currentProductId = dataId.toString();
            this.isShowModal = true;
          }
        });
    },
  },
  mounted() {
    this.createActiveAreaStyle();
    // 3秒后从home-start切换到home-main
    setTimeout(() => {
      document.querySelector(".home-start").style.opacity = "0";
      document.querySelector(".home-main").style.display = "block";
      setTimeout(() => {
        document.querySelector(".home-main").style.opacity = "1";
      },50)
    }, 3000)
    if (process.env.NODE_ENV === "development") {
      // Use local data in development
      this.allPictureInfo = pictureInfo;
      // this.initViewer();
      this.loadExternalScript();
    } else {
      // Fetch remote data in production
      fetch(
        "https://media.tp-link.com.cn/webresource/act/vr/pictureInfo.json?" +
          Date.now(),
        {
          mode: "cors",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.allPictureInfo = data;
          // this.initViewer();
          this.loadExternalScript();
        })
        .catch((error) => {
          console.error(
            "Error fetching remote data, falling back to local data:",
            error
          );
          this.allPictureInfo = pictureInfo;
          // this.initViewer();
          this.loadExternalScript();
        });
    }
  },
};
</script>

<style lang="scss">
@use "sass:math";

@function px2vw($px) {
  @return math.div(100px * $px, 1920px) * 1vw;
}
@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}
@font-face {
  font-family: "SourceHanSansCN-Bold";
  src: url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot");
  src: url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot")
      format("embedded-opentype"),
    url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.woff")
      format("woff"),
    url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.ttf")
      format("truetype"),
    url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.svg")
      format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSansCN-Normal";
  src: url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Normal.eot");
  src: url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Normal.eot")
      format("embedded-opentype"),
    url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Normal.woff")
      format("woff"),
    url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Normal.ttf")
      format("truetype"),
    url("https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Normal.svg")
      format("svg");
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -o-font-smoothing: antialiased;
}

.home{
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  .home-start{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.5s;
    img{
      width: px2vw(405);
    }
  }
  .home-main{
    height: 100%;
    position: relative;
    opacity: 0;
    display: none;
    transition: all 0.5s;
    img{
      display: block;
      height: 100%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    &::after{
      content: "";
      position: absolute;
      background: #f2f2f2;
      width: 200%;
      height: 30%;
      bottom: 0;
      left: -50%;
      z-index: 1;
    }
    .home-main-btns{
      width: px2vh(660);
      height: px2vh(80);
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 80.1%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      .home-main-btn{ 
        width: px2vh(180);
        height: px2vh(80);
        display: flex;
        align-items: center;
        justify-content: center;
        background: #41558C;
        font-size: px2vh(32);
        font-family: SourceHanSansCN-Bold;
        color: #fff;
        letter-spacing: px2vh(0.64);
        cursor: pointer;
        font-weight: normal;
        border-radius: px2vh(12);
        &:hover{
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }
  @media (max-width:600px) {
    .home-main{
      img{
        display: block;
        height: 80%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      &::after{
        content: "";
        position: absolute;
        background: #f2f2f2;
        width: 200%;
        height: 40%;
        bottom: 0;
        left: -50%;
        z-index: 1;
      }
      .home-main-btns{
        width: 80%;
        height: px2vh(80);
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 80.1%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        .home-main-btn{ 
          width: 30%;
          height: px2vh(80);
          display: flex;
          align-items: center;
          justify-content: center;
          background: #41558C;
          font-size: px2vh(32);
          font-family: SourceHanSansCN-Bold;
          color: #fff;
          letter-spacing: px2vh(0.64);
          cursor: pointer;
          font-weight: normal;
          border-radius: px2vh(12);
          &:hover{
            color: rgba(255, 255, 255, 0.7);
          }
        }
      }
    }
  }
}

.scene-link {
  cursor: pointer;
  padding: 0 px2vw(30);
}

.custom-tooltip {
  max-width: none;
  /* width: 300px; */
  /* box-shadow: 0 0 0 3px white; */
  box-shadow: none;
  padding: px2vw(9) px2vw(19);
  /* cursor: pointer; */
  font-weight: normal;
}

.psv-tooltip {
  cursor: pointer;
}

.psv-marker--has-tooltip {
  visibility: hidden;
}

.custom-tooltip .psv-tooltip-content {
  padding: 0;
  font-family: SourceHanSansCN-Bold;
  font-size: px2vw(16);
  text-shadow: none;
  letter-spacing: px2vw(0.32);
  font-weight: normal;
  font: px2vw(16) SourceHanSansCN-Bold;
  font-weight: 400;
}

.custom-tooltip img {
  width: 100%;
  border-radius: px2vw(4) px2vw(4) 0 0;
}

.custom-tooltip h2,
.custom-tooltip p {
  margin: 1rem;
  text-align: justify;
}

/* 隐藏箭头 */
.custom-tooltip .psv-tooltip-arrow {
  display: none !important;
}

.custom-maker-container {
  width: px2vw(36);
  height: px2vw(36);
  display: flex;
  align-content: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  margin-top: -1vw;
  &.no-cursor{
    cursor: default;
  }
  .product-hover {
    position: absolute;
  }
  .tooltipitem {
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
    border-radius: px2vw(24) px2vw(24) px2vw(24) 0;
    bottom: px2vw(18);
    left: px2vw(18);
    padding: px2vw(10) px2vw(36);
    z-index: 1;
    &.big {
      border-radius: px2vw(34) px2vw(34) px2vw(34) 0;
    }
    .tip-normal {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vw(18);
      color: #000000;
      letter-spacing: px2vw(0.36);
      text-align: left;
      line-height: px2vw(28);
      font-weight: 400;
      white-space: nowrap;
    }
    .tip-preview{
      font-family: SourceHanSansCN-Medium;
      font-size: px2vw(14);
      color: #838383;
      letter-spacing: 0;
      text-align: center;
      line-height: px2vw(20);
      font-weight: 400;
      margin-top: px2vw(2);
      text-align: left;
      border-bottom: 1px solid #838383;
      display: inline-block;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        color: #2787fe;
        border-bottom: 1px solid #2787fe;
      }
    }
    .tip-grey {
      font-family: SourceHanSansCN-Medium;
      font-size: px2vw(14);
      color: #838383;
      letter-spacing: 0;
      text-align: center;
      line-height: px2vw(20);
      font-weight: 400;
      margin-top: px2vw(2);
      text-align: left;
      display: inline-block;
      white-space: nowrap;
    }
  }
  .tooltipitem2{
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
    border-radius: px2vw(24);
    bottom: 0;
    left: px2vw(30.5);
    padding: px2vw(10) px2vw(42);
    z-index: 1;
    .tip-normal {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vw(18);
      color: #000000;
      letter-spacing: px2vw(0.36);
      text-align: left;
      line-height: px2vw(28);
      font-weight: 400;
      white-space: nowrap;
    }
  }
  .custom-maker-icon {
    width: px2vw(36);
    height: px2vw(36);
    position: relative;
    z-index: 2;
  }
  .custom-maker-icon2 {
    width: px2vw(60);
    height: px2vw(60);
    position: relative;
    z-index: 2;
  }
}
.custom-maker-container2{
  width: px2vw(60);
  height: px2vw(60);
  display: flex;
  align-content: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  margin-top: -1vw;
  .tooltipitem{
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
    border-radius: px2vw(24);
    bottom: px2vw(6);
    left: px2vw(30.5);
    padding: px2vw(10) px2vw(42);
    z-index: 1;
    .tip-normal {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vw(18);
      color: #000000;
      letter-spacing: px2vw(0.36);
      text-align: left;
      line-height: px2vw(28);
      font-weight: 400;
      white-space: nowrap;
    }
  }
  
  .custom-maker-icon {
    width: px2vw(60);
    height: px2vw(60);
    position: relative;
    z-index: 2;
  }
}
@media screen and (max-width:2240px) {
    .custom-maker-container {
      margin-top: 2px;
    }
    .custom-maker-container2 {
      margin-top: 2px;
    }
}
@media screen and (max-width:1900px) {
    .custom-maker-container {
      margin-top: 0.6vw;
    }
    .custom-maker-container2 {
      margin-top: 0.6vw;
    }
}
</style>
